import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { InstallationPredictedStatus } from "@/model/data/predictiveMaintenance/InstallationPredictedStatus";
import { InstallationPredictedStatusEnum } from "@/model/data/predictiveMaintenance/InstallationPredictedStatusEnum";

export class FetchInstallationsPredictedStatusResponse extends ApiGenericResponse {
    installationsList: InstallationPredictedStatus[];
    totalInstallationsCount: number;
    installationsCountByPredictedStatus: Map<InstallationPredictedStatusEnum, number>;
    filteredInstallationsCountByPredictedStatus: Map<InstallationPredictedStatusEnum, number>;

    constructor(response: AxiosResponse) {
        super(response);
        this.installationsList = [];
        this.totalInstallationsCount = 0;
        this.installationsCountByPredictedStatus = new Map<InstallationPredictedStatusEnum, number>();
        this.filteredInstallationsCountByPredictedStatus = new Map<InstallationPredictedStatusEnum, number>();
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.DevicesPredictedStatus && obj.DevicesPredictedStatus.length > 0) {
            obj.DevicesPredictedStatus.forEach((e) => {
                let inst = new InstallationPredictedStatus();
                inst.parse(e);
                this.installationsList.push(inst);
                //console.log(this.installationsList)
            });
        }
        if (obj.TotalDeviceStatusCount) this.totalInstallationsCount = obj.TotalDeviceStatusCount;

        if (obj.TotalCountByPredictedStatus) {
            for (let key in obj.TotalCountByPredictedStatus) {
                if (key != null && Object.values(InstallationPredictedStatusEnum).includes(key)) {
                    this.installationsCountByPredictedStatus.set(InstallationPredictedStatusEnum[key], obj.TotalCountByPredictedStatus[key]);
                }
            }
        }
        if (obj.FilteredTotalCountByPredictedStatus) {
            for (let key in obj.FilteredTotalCountByPredictedStatus) {
                if (key != null && Object.values(InstallationPredictedStatusEnum).includes(key)) {
                    this.filteredInstallationsCountByPredictedStatus.set(InstallationPredictedStatusEnum[key], obj.FilteredTotalCountByPredictedStatus[key]);
                }
            }
        }
    }
}
